// extracted by mini-css-extract-plugin
module.exports = {"randomArticles":"Shop_randomArticles__3TQ5h"};